<template>
  <div>
    <div class="row no-gutters pb-4">
      <div class="col-12">
        <tabs :tabs="tabs"
              :disablePadding="true"
              ref="tabs"/>
      </div>
      <div class="col-12 d-flex justify-content-end align-items-center pr-4 my-2">
        <button class="btn ls-btn-tertiary s-12 px-1" @click="clear">
          Clear
        </button>
      </div>
      <div class="col-12">
        <div class="row no-gutters px-4 mt-2">
          <div class="col-6 pr-1">
            <div class="btn ls-btn-tertiary s-12 px-4 py-3"
                 @click="close"
                 style="width: 100%">
              Cancel
            </div>
          </div>
          <div class="col-6 pl-1">
            <div class="btn ls-btn-secondary s-12 px-4 py-3"
                 @click="sign"
                 style="width: 100%">
              Sign
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tabs from '@/modules/common/components/tab/Tabs.vue';
import ContractServices from '@/modules/contract/services/contract.services';
import ImageDataConverter from '@/modules/common/services/imageDataConverter.service';
import ActivityService from '@/modules/common/services/activity.service';

const Draw = () => import('./Draw.vue');
const Text = () => import('./Text.vue');

export default {
  name: 'Signature',
  props: {
    modalConfig: {
      required: true,
    },
  },
  data() {
    return {
      tabs: [{
        title: 'Text',
        name: 'text',
        active: true,
        load: true,
        components: [{
          name: this.produceKey(),
          stack: Text,
        }],
      },
      {
        title: 'Draw',
        name: 'draw',
        active: false,
        load: false,
        components: [{
          name: this.produceKey(),
          stack: Draw,
        }],
      }],
    };
  },
  created() {
    // opened signature modal activity.
    setTimeout(() => new ActivityService().record(this.$route.params.document_unique_key, 173), 0);
  },
  methods: {
    async sign() {
      const activeTab = this.tabs.find((t) => t.active);
      const tab = this.$refs.tabs.$refs[activeTab.name][0];

      await tab.save();

      if (tab.image) {
        const formData = new FormData();
        await formData.append('contact_signature_type', activeTab.name);

        await formData.append('contact_signature', ImageDataConverter(tab.image), 'image.jpg');
        try {
          const result = await new ContractServices().sign(this.$route.params.document_unique_key, formData);
          if (result) {
            // signed contract
            setTimeout(() => new ActivityService().record(this.$route.params.document_unique_key, 174), 0);
            this.$emit('signed', tab.image);
            this.close();
          }
        } catch (e) {
          this.errorMessage(e[0]);
        }
      }
    },
    clear() {
      const activeTab = this.tabs.find((t) => t.active);

      const tab = this.$refs.tabs.$refs[activeTab.name][0];

      tab.clear();
    },
    close() {
      this.modalConfig.show = false;
    },
  },
  components: {
    Tabs,
  },
};
</script>
